import React from 'react';
import { motion } from 'framer-motion';
export function Results() {
  const results = [{
    sector: 'E-commerce · Suplementos',
    roi: '4,6',
    unit: 'x',
    desc: 'ROAS sostenido durante 5 meses escalando inversión de 3.000€ a 22.000€/mes sin romper el coste por compra.',
    quote: '"Pasamos de probar a tener un sistema."'
  }, {
    sector: 'Servicios · Captación local',
    roi: '-52',
    unit: '%',
    desc: 'Reducción del coste por lead en 6 semanas reestructurando campañas y reescribiendo creatividades de cero.',
    quote: '"La agenda no para de llenarse."'
  }, {
    sector: 'Formación · Lead gen',
    roi: '+310',
    unit: '%',
    desc: 'Aumento de leads cualificados mensuales con un embudo nuevo y tracking de eventos bien medido.',
    quote: '"Por fin sé qué anuncio me trae clientes."'
  }];
  return <section className="relative py-[110px] bg-bg-2 border-y border-line" id="resultados" data-id="element-151">
      <div className="max-w-wrap mx-auto px-7" data-id="element-152">
        <motion.div initial={{
        opacity: 0,
        y: 34
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-10%'
      }} transition={{
        duration: 0.8,
        ease: [0.2, 0.7, 0.2, 1]
      }} className="flex items-end justify-between gap-[30px] mb-[64px] flex-wrap" data-id="element-153">
          <div data-id="element-154">
            <div className="font-mono text-[0.74rem] tracking-[0.16em] text-acid uppercase flex items-center gap-[10px] mb-5 before:content-[''] before:w-[28px] before:h-[1px] before:bg-acid" data-id="element-155">
              Resultados
            </div>
            <h2 className="text-[clamp(2rem,4.6vw,3.5rem)] font-bold tracking-[-0.03em] leading-[1.02] max-w-[18ch]" data-id="element-156">
              Números, no{' '}
              <span className="font-serif italic font-normal" data-id="element-157">promesas.</span>
            </h2>
          </div>
          <p className="max-w-[38ch] text-ink-dim text-[1.05rem]" data-id="element-158">
            Una selección de lo que conseguimos cuando nos dejan trabajar con
            método. Cada caso, una cuenta real escalada.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-[30px]" data-id="element-159">
          {results.map((res, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 34
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-10%'
        }} transition={{
          duration: 0.8,
          ease: [0.2, 0.7, 0.2, 1],
          delay: i * 0.07
        }} className="border border-line rounded-[18px] p-[34px] bg-card relative overflow-hidden before:content-[''] before:absolute before:top-0 before:left-0 before:right-0 before:h-[2px] before:bg-[linear-gradient(90deg,var(--acid),transparent)]" data-id="element-160">
              <div className="font-mono text-[0.72rem] tracking-[0.1em] text-ink-faint uppercase mb-[22px]" data-id="element-161">
                {res.sector}
              </div>
              <div className="text-[3rem] font-extrabold tracking-[-0.03em] leading-none text-ink" data-id="element-162">
                {res.roi}
                <span className="text-acid text-[1.6rem]" data-id="element-163">{res.unit}</span>
              </div>
              <div className="text-ink-dim text-[0.94rem] mt-[14px]" data-id="element-164">
                {res.desc}
              </div>
              <div className="mt-[24px] pt-[22px] border-t border-line italic font-serif text-[1.15rem] text-ink" data-id="element-165">
                {res.quote}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}